
/**
 * app.js
 * (Empty) entry point for site javascript
 * All .js files in /app are bundled into this and minified
 */


// Clickjack protection
if (top && top != window) {
  top.location = window.location.toString();
}



import './app/a11y.ts'; 
import './app/anim-utils.ts'; 
import './app/accordion.ts';
import './app/analytics.ts';
import './app/animations.ts';
import './app/carousel-tiles.ts';
import './app/carousel.ts';
import './app/clarity.ts';
import './app/focus-trap.ts';
import './app/hash-scroll.ts';
import './app/forms.ts';

import './app/modal.ts';
import './app/nav.ts';
import './app/onetrust.ts';
import './app/playpause.ts';
import './app/tag-list.ts';
import './app/impact.ts';
import './app/text-media.ts';
import './app/ticker.ts';
import './app/parallax.ts';
import './app/elastic-carousel-hero.ts';
import './app/tiles-teaser.ts';
import './app/video-lightbox.ts';

